import { type Computed, computed } from 'easy-peasy'
import { DomainEnum } from '@strata-monorepo/shared-types/src/Domain'
import type { FMPStoreModel } from '../../types'

export interface SiteConfigModel {
  // State
  siteDomain: DomainEnum | null

  // Computed
  siteName: Computed<SiteConfigModel, string, FMPStoreModel>
}

export const siteConfigModel = (siteDomain: DomainEnum | null): SiteConfigModel => ({
  // State
  siteDomain,

  // Computed
  siteName: computed((state) => {
    switch (state.siteDomain) {
      case DomainEnum.CTXP:
        return 'Choose Texas Power'
      case DomainEnum.TXER:
        return 'Texas Electric Rates'
      case DomainEnum.SOE:
        return 'Save on Energy'
      case DomainEnum.CHOOSE:
        return 'Choose Energy'
      default:
        return ''
    }
  }),
})
